import { render, staticRenderFns } from "./MentionBox.vue?vue&type=template&id=305f625c&scoped=true&"
import script from "./MentionBox.vue?vue&type=script&setup=true&lang=js&"
export * from "./MentionBox.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MentionBox.vue?vue&type=style&index=0&id=305f625c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305f625c",
  null
  
)

export default component.exports